<template>
  <Flex center v-bind="$attrs" class="cursor-pointer min-w-10 h-10 px-2">
    <i :class="icon" v-if="icon"></i>
    <slot></slot>
  </Flex>
</template>

<script setup>
const props = defineProps({
  icon: String,
})
</script>
